import { render, staticRenderFns } from "./detailsCFS.vue?vue&type=template&id=eabfe54c&scoped=true"
import script from "./detailsCFS.vue?vue&type=script&lang=js"
export * from "./detailsCFS.vue?vue&type=script&lang=js"
import style0 from "./detailsCFS.vue?vue&type=style&index=0&id=eabfe54c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabfe54c",
  null
  
)

export default component.exports